import type { TransitionStep } from '../../api';

export const SEND_SMS_TASK = 'send_sms';

export type SendSmsStepFormState = {
  id: string;
  step_order: number;
  timeout: number;
  retries: number;
  sender_name: string;
  message_text: string;
  phone_column: string;
};

function asRecord(value: unknown): Record<string, unknown> {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return {};
}

function asString(value: unknown, fallback = ''): string {
  if (value == null) return fallback;
  return String(value);
}

function asNumber(value: unknown, fallback: number): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function defaultSendSmsStep(opts?: {
  stepOrder?: number;
  senderName?: string;
}): SendSmsStepFormState {
  return {
    id: '',
    step_order: opts?.stepOrder ?? 1,
    timeout: 120,
    retries: 1,
    sender_name: opts?.senderName ?? '',
    message_text: '',
    phone_column: 'phone',
  };
}

export function parseSendSmsStep(row: TransitionStep): SendSmsStepFormState {
  const settings = asRecord(row.settings);
  return {
    id: row.id,
    step_order: row.step_order,
    timeout: row.timeout,
    retries: asNumber(settings.retries, 1),
    sender_name: asString(settings.sender_name),
    message_text: asString(settings.message_text),
    phone_column: asString(settings.phone_column, 'phone') || 'phone',
  };
}

export function toStepPayload(
  form: SendSmsStepFormState,
  systemId: string,
): { step_order: number; timeout: number; settings: Record<string, never> } {
  const settings = {
    task: SEND_SMS_TASK,
    retries: Number(form.retries) || 0,
    sender_name: form.sender_name.trim(),
    message_text: form.message_text,
    phone_column: form.phone_column.trim() || 'phone',
    system_id: systemId,
  };
  return {
    step_order: form.step_order,
    timeout: form.timeout,
    settings: settings as unknown as Record<string, never>,
  };
}

export function formatStepSettings(row: TransitionStep): string {
  const settings = asRecord(row.settings);
  const task = asString(settings.task, SEND_SMS_TASK) || '—';
  const text = asString(settings.message_text, '—') || '—';
  const retries = settings.retries != null ? String(settings.retries) : '—';
  return `задача: ${task}, текст: ${text}, попыток: ${retries}`;
}
